import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, circularProgressClasses, styled, Typography } from "@mui/material";
import { useId } from "react";
const StyledCircularProgress = styled(CircularProgress)({
    [`& .${circularProgressClasses.circle}`]: {
        strokeLinecap: 'round'
    },
    left: 0,
    position: 'absolute'
});
const StyledLabel = styled('div')({
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
});
export const CircularChart = ({ size = 25, ...props })=>{
    const id = useId();
    const formattedValue = Number.isFinite(props.value) ? props.value : 0;
    return /*#__PURE__*/ _jsxs(Box, {
        "data-component": "chart",
        "data-testid": "goal",
        "data-value": formattedValue?.toString(),
        sx: {
            height: `${size}px`,
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ _jsx(CircularProgress, {
                "aria-hidden": "true",
                color: props.color,
                size: size,
                sx: {
                    opacity: 0.2
                },
                thickness: props.thickness,
                value: 100,
                variant: "determinate"
            }),
            /*#__PURE__*/ _jsx(StyledCircularProgress, {
                "aria-labelledby": id,
                color: props.color,
                size: size,
                thickness: props.thickness,
                value: formattedValue >= 100 ? 100 : formattedValue,
                variant: "determinate"
            }),
            !props.hideLabel && /*#__PURE__*/ _jsxs(StyledLabel, {
                id: id,
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        fontSize: size / 4,
                        fontWeight: "bold",
                        lineHeight: 1,
                        children: [
                            formattedValue,
                            "%"
                        ]
                    }),
                    props.label && /*#__PURE__*/ _jsx(Typography, {
                        fontSize: size / 8,
                        lineHeight: 1,
                        children: props.label
                    })
                ]
            })
        ]
    });
};
CircularChart.displayName = 'CircularChart';

//# sourceMappingURL=CircularChart.js.map